"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subtractTradingDays = void 0;
const isTradingDay_1 = require("../isTradingDay");
const parseInputDate_1 = require("../../utils/parseInputDate");
function subtractTradingDays(date, daysToSubtract) {
    let dateTime = (0, parseInputDate_1.parseInputDate)(date);
    if (!dateTime) {
        throw Error('Invalid date value');
    }
    if (daysToSubtract < 0) {
        throw RangeError;
    }
    if (daysToSubtract > 450) {
        throw RangeError;
    }
    let isoDate = dateTime.toISODate();
    if (daysToSubtract === 0) {
        return isoDate;
    }
    let forLimit = daysToSubtract;
    for (let i = 1; i <= forLimit; i++) {
        dateTime = dateTime.minus({ days: 1 });
        isoDate = dateTime.toISODate();
        if (!(0, isTradingDay_1.isTradingDay)(isoDate)) {
            forLimit += 1;
        }
    }
    return isoDate;
}
exports.subtractTradingDays = subtractTradingDays;
//# sourceMappingURL=index.js.map